import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './shared/components/layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './shared/components/layouts/auth-layout/auth-layout.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { KycAccessGuard } from './shared/guards/kyc-access.guard';
import { SupplierDetailComponent } from './views/settings/suppliers/supplier-detail/supplier-detail.component';
import { MySupplierDetailComponent } from './views/settings/buyers/my-suppliers/my-supplier-detail/my-supplier-detail.component'
//import { AdminDashboardComponent } from './views/dashboard/admin/admin-dashboard/admin-dashboard.component';

import { AppComponent } from './app.component';
import { TokenLoginComponent } from './views/tokenBasedScreens/tokenLogin/tokenLogin-component';
import { RfqTokenDetailsComponent } from './views/tokenBasedScreens/rfqDetails/rfqDetails.component';
import { RfqTokenQuoteLineItemsComponent } from './views/tokenBasedScreens/quote-line-items/quote-line-items.component';
import { RfqTokenQuoteFormHeaderComponent } from './views/tokenBasedScreens/quote-form-header/quote-form-header.component';
import { RfqTokenQuotePaymentTermsComponent } from './views/tokenBasedScreens/quote-payment-terms/quote-payment-terms.component';
import { RfqTokenQuoteFormPreviewComponent } from './views/tokenBasedScreens/quote-preview/quote-form-preview.component';
import { KycTokenSubmitPageComponent } from './views/tokenBasedScreens/kyc-token-submit-page/kyc-token-submit-page.component';
import { KycTokenLoginComponent } from './views/tokenBasedScreens/kycTokenLogin/kycTokenLogin.component';
import { ServiceTokenLoginComponent } from './views/serviceTokenBasedScreens/serviceTokenLogin/serviceTokenLogin.component';
import { ServiceRfqTokenDetailsComponent } from './views/serviceTokenBasedScreens/serviceRfqDetails/serviceRfqDetails.component';
import { ServiceRfqTokenQuoteLineItemsComponent } from './views/serviceTokenBasedScreens/serviceQuoteLineItems/serviceQuoteLineItems.component';
import { ServiceRfqTokenQuoteFormHeaderComponent } from './views/serviceTokenBasedScreens/serviceQuoteFormHeader/serviceQuoteFormHeader.component';
import { ServiceRfqTokenQuotePaymentTermsComponent } from './views/serviceTokenBasedScreens/serviceQuotePaymentTerms/serviceQuotePaymentTerms.component';
import { ServiceRfqTokenQuotePreviewComponent } from './views/serviceTokenBasedScreens/serviceQuotePreview/serviceQuotePreview.component';
import { ServicePoTokenLoginComponent } from './views/serviceTokenBasedScreens/servicePoTokenLogin/servicePoTokenLogin.component';
import { ServicePoTokenDetailsComponent } from './views/serviceTokenBasedScreens/servicePoTokenDetails/servicePoTokenDetails.component';
export const rootRouterConfig: Routes = [
  // // Public short URL that redirects to the existing operations token-login route
  // { path: 'token-login', redirectTo: '/operations/token-login', pathMatch: 'full' ,data: { title: 'VS-MPS | Token Login', breadcrumb: 'Settings' }},
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [KycAccessGuard],
    children: [
      {
        path: "supplier-detail",
        component: SupplierDetailComponent,
        outlet: "form-outlet",
        canActivate: [AuthGuard],
      },
      {
        path: 'buyer-data-management',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/buyer-data-Management/buyer-data-Management.module').then(m => m.BuyerDataManagementModule),
        data: { title: 'Buyer Data Management', breadcrumb: 'buyer-data-management' }
      },
      {
        path: 'notifications-list',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/notifications/notifications.module').then(m => m.NotificationsModule),
        data: { title: 'Notifications', breadcrumb: 'notifications' }
      },
      {
        path: 'admin/notifications',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/notifications/admin-notifications-list/admin-notifications.module').then(m => m.AdminNotificationsModule),
        data: { title: 'Admin Notifications', breadcrumb: 'admin-notifications' }
      },
      {
        path: "my-supplier-detail",
        component: MySupplierDetailComponent,
        outlet: "form-outlet",
        canActivate: [AuthGuard],
      },
      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule),
        data: { title: 'Dashboard', breadcrumb: 'DASHBOARD' }
      },
      {
        path: 'supplier',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/supplier/supplier.module').then(m => m.SupplierModule),
        data: { title: 'Supplier', breadcrumb: 'SUPPLIER' }
      },
      {
        path: 'search',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/search/search.module').then(m => m.SearchModule),
        data: { title: 'Search', breadcrumb: 'Search' }
      },
      {
        path: 'environmental',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/environmental/environmental.module').then(m => m.EnvironmentalModule),
        data: { title: 'Environmental', breadcrumb: 'environmental' }
      },
      {
        path: 'social',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/social/social.module').then(m => m.socialDashboardModule),
        data: { title: 'Social', breadcrumb: 'social' }
      },
      {
        path: 'administration',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/administration/administration.module').then(m => m.AdministrationModule),
        data: { title: 'Administration', breadcrumb: 'administration' }
      },
      {
        path: 'settings',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/settings/settings.module').then(m => m.SettingsModule),
        data: { title: 'Settings', breadcrumb: 'settings' }
      },
      {
        path: 'dataManagement',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/settings/data-management.module').then(m => m.DataManagementModule),
        data: { title: 'Settings', breadcrumb: 'settings' }
      },
      {
        path: 'buyer-data-management',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/buyer-data-Management/buyer-data-Management.module').then(m => m.BuyerDataManagementModule),
        data: { title: 'Buyer Data Management', breadcrumb: 'buyer-data-management' }
      },
      {
        path: 'dashboard/admin',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/dashboard/admin/admin.module').then(m => m.AdminModule),
        data: { title: 'dashboard', breadcrumb: 'dashboard' }
      },
      {
        // Admin: Buyer Vessels (MPS-222). Top-level so it renders without
        // AdminDashboardComponent's secondary sidebar.
        path: 'admin/vessel-details-lists',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/dashboard/admin/buyer-vessels/buyer-vessels.module').then(m => m.BuyerVesselsModule),
        data: { title: 'Buyer Vessels', breadcrumb: 'Buyer Vessels' }
      },
      {
        // 2026-10-24 Batch B (P8): Admin · Port coverage report (suppliers by the ports they serve).
        path: 'admin/port-coverage',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/dashboard/admin/port-coverage/port-coverage.module').then(m => m.PortCoverageModule),
        data: { title: 'Port coverage', breadcrumb: 'Port coverage' }
      },
      {
        // Admin: Settings — banking / company / invoicing configuration used
        // by the buyer & supplier invoicing flows. Top-level like the other
        // admin screens. Author: Akarsh Singh | 2026-07-11
        path: 'admin/settings',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/dashboard/admin/admin-settings/admin-settings.module').then(m => m.AdminSettingsModule),
        data: { title: 'Admin Settings', breadcrumb: 'Admin Settings' }
      },
      {
        path: 'operations',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/operations/operations.module').then(m => m.OperationsModule),
        data: { title: 'Settings', breadcrumb: 'settings' }
      },
      {
        path: 'userManagement',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/userManagement/userManagement.module').then(m => m.UserManagementModule),
        data: { title: 'userManagement', breadcrumb: 'userManagement' }
      },
      {
        path: 'marketplace-supplier',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/marketplace-supplier/marketplaceSupplier.module').then(m => m.MarketplaceSupplierModule),
        data: { title: 'Marketplace', breadcrumb: 'Marketplace' }
      },
    ]
  },
  {
    path: '',
    component: AppComponent,
    pathMatch: 'full'
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./views/auth/auth.module').then(m => m.AuthModule),
        data: { title: 'Session' }
      },
      {
        path: 'tokenLogin',
        component: TokenLoginComponent,
        data: { title: 'Token Login' }
      },
      {
        path: 'rfqToken/rfqDetails/:rfqId',
        component: RfqTokenDetailsComponent,
        data: { title: 'RFQ Token Details' }
      },
      {
        path: 'rfqToken/quote-line-items',
        component: RfqTokenQuoteLineItemsComponent,
        data: { title: 'RFQ Token Quote Line Items' }
      },
      {
        path: 'rfqToken/quote-header-details',
        component: RfqTokenQuoteFormHeaderComponent,
        data: { title: 'RFQ Token Quote Header' }
      },
      {
        path: 'rfqToken/quote-payment-terms',
        component: RfqTokenQuotePaymentTermsComponent,
        data: { title: 'RFQ Token Quote Payment Terms' }
      },
      {
        path: 'rfqToken/quote-preview',
        component: RfqTokenQuoteFormPreviewComponent,
        data: { title: 'RFQ Token Quote Preview' }
      },
      {
        // MPS-215 Public gate page for the KYC magic-link flow. The
        // supplier lands here from the invitation email, types their
        // Unique Access Token, and on success is forwarded to
        // /kycToken/submit?token=… (mirrors the RFQ /tokenLogin →
        // /rfqToken/rfqDetails pattern).
        path: 'kycTokenLogin',
        component: KycTokenLoginComponent,
        data: { title: 'KYC Token Login' }
      },
      {
        // Public KYC document submission page reached via the magic
        // link in the buyer's KYC invitation email. Sits under the
        // AuthLayout (no auth guard) — token verification happens on
        // page load against the kycTokenDetails table.
        path: 'kycToken/submit',
        component: KycTokenSubmitPageComponent,
        data: { title: 'KYC Document Submission' }
      },
      {
        path: 'serviceTokenLogin',
        component: ServiceTokenLoginComponent,
        data: { title: 'Service RFQ Token Login' }
      },
      {
        path: 'serviceRfqToken/rfqDetails/:serviceRfqId',
        component: ServiceRfqTokenDetailsComponent,
        data: { title: 'Service RFQ Token Details' }
      },
      {
        path: 'serviceRfqToken/quote-line-items',
        component: ServiceRfqTokenQuoteLineItemsComponent,
        data: { title: 'Service RFQ Token Quote Line Items' }
      },
      {
        path: 'serviceRfqToken/quote-header-details',
        component: ServiceRfqTokenQuoteFormHeaderComponent,
        data: { title: 'Service RFQ Token Quote Header' }
      },
      {
        path: 'serviceRfqToken/quote-payment-terms',
        component: ServiceRfqTokenQuotePaymentTermsComponent,
        data: { title: 'Service RFQ Token Quote Payment Terms' }
      },
      {
        path: 'serviceRfqToken/quote-preview',
        component: ServiceRfqTokenQuotePreviewComponent,
        data: { title: 'Service RFQ Token Quote Preview' }
      },
      {
        path: 'servicePoTokenLogin',
        component: ServicePoTokenLoginComponent,
        data: { title: 'Service PO Token Login' }
      },
      {
        path: 'servicePoToken/po-details',
        component: ServicePoTokenDetailsComponent,
        data: { title: 'Service PO Token Details' }
      },
      {
        path: 'marketplace',
        loadChildren: () => import('./views/marketplace/marketplace.module').then(m => m.MarketplaceModule),
        data: { title: 'marketplace', breadcrumb: 'marketplace' }
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule),
        data: { title: 'Dashboard', breadcrumb: 'Dashboard' }
      },
      {
        path: 'emissions',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/environmental/emissions/emissions.module').then(m => m.EmissionsModule),
        data: { title: 'Emissions', breadcrumb: 'Emissions' }
      },
      {
        path: 'administration',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/administration/administration.module').then(m => m.AdministrationModule),
        data: { title: 'Administration', breadcrumb: 'Administration' }
      },
      {
        path: 'social-dashboard',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/social/social-dashboard/social-dashboard.module').then(m => m.socialDashboardModule),
        data: { title: 'social-dashboard', breadcrumb: 'social-dashboard' }
      },
      {
        path: 'settings',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/settings/settings.module').then(m => m.SettingsModule),
        data: { title: 'Settings', breadcrumb: 'settings' }
      },
      {
        path: 'dataManagement',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/settings/data-management.module').then(m => m.DataManagementModule),
        data: { title: 'Settings', breadcrumb: 'settings' }
      },

      {
        path: 'dashboard/admin',
        canActivate: [AuthGuard],
        loadChildren: () => import('./views/dashboard/admin/admin.module').then(m => m.AdminModule),
        data: { title: 'dashboard', breadcrumb: 'dashboard' }
      },
      //{ path: '', redirectTo: 'dashboard/admin', pathMatch: 'full' },  // Default route
      //{ path: 'dashboard/admin', loadChildren: () => import('./views/dashboard/admin/admin.module').then(m => m.AdminModule) },
    ]
  },
  {
    path: 'overview',
    redirectTo: '/auth/signin',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'sessions/404'
  }
];

